<template>
    <div id="home-page" class="wide content">
        <div class="main-files">
            <h3>
              <template v-for="(path, index) in display_path">
                <router-link class="path-display-link" :to="pathUrls[index]">{{ path }}</router-link>
                <template v-if="index < display_path.length - 1"> › </template>
              </template>
            </h3>

            <toolbox :selected="selectedItems" @save-folder="saveFolder" @refresh-items="doRefresh" @update-sorting="doRefresh" @select-all="selectAll" @select-none="selectNone" />
            <alpha-nav v-if="isHome" />

            <file-list ref="fileList" v-model="cwd" @update-selected="updateSelected" @loaded="handleScroll" />
            <div class="instructions">
              <p>
              <img src="../assets/red-padlock.png" alt="Lock Icon" />
              Note: You may click on locked folders to request access.
              </p>
            </div>
        </div>
        <div class="quick-files">
            <h3>My Portfolio</h3>
            <portfolio />
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import FileList from '../components/FileList.vue'
import Toolbox from '../components/Toolbox.vue'
import Portfolio from '../components/Portfolio.vue'
import AlphaNav from '../components/AlphaNav.vue'

import {mapState} from 'vuex'

export default {
  name: 'home-page',
  components: {FileList, Toolbox, Portfolio, AlphaNav},
  data() {
    return {
      // cwd: {},
      display_path: [],
      selectedItems: [],
      pathUrls: [],
    }
  },
  computed: {
    ...mapState(['cwd', 'sortMethod', 'viewOptions']),
    isHome() {
      return this.$route.fullPath == '/'
    },
    pageTitle() {
      return this.cwd.display_name ? this.cwd.display_name : 'Home'
    },
    folderPath() {
      if (this.cwd.folder == 'Root' || this.cwd.folder === undefined) {
        return 'Home'
      }

      // let parts = this.cwd.folder.split('.')
      // let p = parts.slice(1, parts.length - 1)
      // p.push(this.cwd.display_name)
      // return p.map(i => i.replace(/_/g, ' ')).join(' › ')

      // return this.display_path.join(' › ')
      return this.display_path
    },
  },
  methods: {
    updateSelected(items) {
      this.selectedItems = items
    },
    selectAll() {
      this.$refs.fileList.selectAll()
    },
    selectNone() {
      this.$refs.fileList.selectNone()
    },
    async getCWD(id=0) {
      // let r = await axios.get('/api/files/get-cwd', {params: {path: id}})
      let params = {}

      if (this.sortMethod) {
        params.order = this.sortMethod
      }

      let r = await axios.get(`/api/files/${id}`, {params})

      if (r.status != 200) {
        return;
      }

      if (id != 0) {
        let r2 = await axios.get(`/api/files/${id}/get-display-path`)
        this.display_path = r2.data.display_path
        this.pathUrls = r2.data.urls
        r.data.file.display_path = r2.data.display_path
      }
      else {
        r.data.file.display_path = ['Home']
        this.display_path = ['Home']
        this.pathUrls = ['/']
      }

      // this.cwd = r.data.file
      this.$store.dispatch('setCwd', r.data.file)
    },
    async saveFolder(data) {
      let r = await axios.post('/api/files/create-folder', {
        file: {
          display_name: data.folderName,
          folder: this.cwd.folder,
          filename: '.',
          public: data.publicFolder,
        }
      })

      this.getCWD(this.$route.params.folder)
    },
    doRefresh() {
      this.getCWD(this.$route.params.folder)
    },
    loadViewOpts(to) {
      let path = to.fullPath

      if (path in this.viewOptions) {

        let viewOpts = this.viewOptions[path]
        // console.log('load view options', to.fullPath, viewOpts.scrollPos)

        // setTimeout(() => {
        //   window.scrollTo(0, viewOpts.scrollPos)
        //   console.log('scroll')
        // }, 100)
        this.$store.dispatch('setSortMethod', viewOpts.sort)
      }
      else {
        // setTimeout(() => {
        //   window.scrollTo(0, 0)
        // }, 100)
        this.$store.dispatch('setSortMethod', '')
      }
    },
    handleScroll() {
      this.loadViewOpts(this.$route)

      let path = this.$route.fullPath
      if (path in this.viewOptions) {

        let viewOpts = this.viewOptions[path]

        // console.log('scroll')
        window.scrollTo(0, viewOpts.scrollPos)
      }
      else {
        window.scrollTo(0, 0)
        // console.log('scroll to 0')
      }
    },
  },
  created() {
    this.loadViewOpts(this.$route)
    this.getCWD(this.$route.params.folder)
  },
  beforeRouteUpdate(to, from, next) {
    // save the view of the folder we're leaving
    this.$store.dispatch('setViewOptions', this.$route.fullPath)

    this.loadViewOpts(to)

    this.getCWD(to.params.folder)
    next()
  },
}
</script>
<style lang="scss">
@import '../scss/include-media';

#home-page {
    padding: 50px 75px;

    @include media('<tablet') {
        padding: 25px;
        min-height: 50vh;
    }
    @include media('>=tablet') {
        padding: 25px;
        min-height: 60vh;
    }

    display: grid;
    grid-template-areas: "main quick";
    grid-template-columns: 3fr 1fr;
    

    h3 {
        font-size: 1.5rem;

        .path-display-link {
          text-decoration: none;
          color: #084a27;
        }
    }

    .main-files {
        grid-area: main;
    }
    .quick-files {
        grid-area: quick;
        background: #F0F0F0;
        padding: 16px 26px;

        h3 {
            line-height: 1;
        }
    }
    .instructions {
      margin: 5rem 1rem 0.5rem;
      padding: 0 1rem;

      img {
        vertical-align: middle;
        position: relative;
        top: -3px;
      }
      p {
        line-height: 1;
        font-size: 13px;
      }
    }
}
</style>
